import {} from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import { BreadcrumbsModule, BreadcrumbsService, FilterValueStoreService } from '@shared/modules/page-settings';
import { UiComponentsModule, WrapperComponent } from '@shared/ui/components';
import { IdleTimeoutService } from '@shared/utils';
import { MenuItem } from 'primeng/api';
import { Breadcrumb } from 'primeng/breadcrumb';
import { filter, map } from 'rxjs/operators';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

@Component({
  selector: 'reza-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.css',
  standalone: true,
  imports: [
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    UiComponentsModule,
    BreadcrumbsModule,
    RouterModule,
    WrapperComponent,
  ],
  providers: [FilterValueStoreService],
})
export class DefaultLayoutComponent implements OnInit {
  hideBreadcrumb = true;
  hideNavbar = true;
  publicFooter = false;

  breadcrumbs$ = this.breadcrumbsService.breadcrumbs$.pipe(
    map((breadcrumbs: Breadcrumb[]) => {
      return [
        {
          icon: 'pi pi-home',
          routerLink: `/`,
          label: 'home',
        } as MenuItem,
        ...breadcrumbs,
      ];
    })
  );

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    @Inject(WINDOW) readonly windowRef: Window,
    private router: Router,
    private idleTimeoutService: IdleTimeoutService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateRouteAttributes();
    });

    this.breadcrumbsService.init();
    this.updateRouteAttributes();
  }

  private updateRouteAttributes(): void {
    let route = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route.firstChild;
    }

    this.hideBreadcrumb = route?.snapshot.data['hideBreadcrumb'] === true;
    this.hideNavbar = route?.snapshot.data['hideNavbar'] === true;
    this.publicFooter = route?.snapshot.data['publicFooter'] === true;
  }

  // Debugovani session timer dialogu, prihodit tlacitko nekam, ktere pusti tuhle funkci a lets go
  startCountdown() {
    this.idleTimeoutService.startInactivityTimer();
  }
}
